module.exports = __webpack_public_path__ + "static/media/rough-example-2.4cbae842.png";